module.exports = __webpack_public_path__ + "img/p18_02.268629af.png";